import * as React from "react";

function SvgWave3Inverted(props) {
  return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1600 200" {...props}><path d="M1413.6 39.3c-157.9 0-338.2 37.7-495.1 67.4-215.6 40.8-328.1 44.6-418.2 41.1S317 127.3 188.4 98.7-10 64.5-10 64.5v150.2h1620V58.8s-68.8-19.5-196.4-19.5z" /></svg>;
}

export default SvgWave3Inverted;